export enum LogSeverity {
    INFO = 'INFO',
    ERROR = 'ERROR',
    WARNING = 'WARNING',
    NOTICE = 'NOTICE',
    DEBUG = 'DEBUG'
}
